import Past from '@/components/Sessions/Past';
import { MemberSessionsPage } from '@/features/adminMemberSessions/AdminMemberSessions';

const PastSessions = () => (
  <MemberSessionsPage>
    <Past />
  </MemberSessionsPage>
);

export default PastSessions;
